export const isProduction = process.env.NODE_ENV === 'production'

export const prefix = isProduction ? '' : '/api'

export const isEmpty = (obj) => {
  var key
  for (key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false
    }
  }
  return true
}


// toFixed兼容方法
Number.prototype.toFixed = function (n) {
  if (n > 20 || n < 0) {
      throw new RangeError('toFixed() digits argument must be between 0 and 20');
  }
  var number = this;
  if (isNaN(number) || number >= Math.pow(10, 21)) {
      return number.toString();
  }
  if (typeof (n) == 'undefined' || n == 0) {
      return (Math.round(number)).toString();
  }

  var result = number.toString();
  var arr = result.split('.');

  // 整数的情况
  if (arr.length < 2) {
      result += '.';
      for (var i = 0; i < n; i += 1) {
          result += '0';
      }
      return result;
  }

  var integer = arr[0];
  var decimal = arr[1];
  if (decimal.length == n) {
      return result;
  }
  if (decimal.length < n) {
      for (var i = 0; i < n - decimal.length; i += 1) {
          result += '0';
      }
      return result;
  }
  result = integer + '.' + decimal.substr(0, n);
  var last = decimal.substr(n, 1);

  // 四舍五入，转换为整数再处理，避免浮点数精度的损失
  if (parseInt(last, 10) >= 5) {
      var x = Math.pow(10, n);
      result = (Math.round((parseFloat(result) * x)) + 1) / x;
      result = result.toFixed(n);
  }

  return result;
};

// socket 数据格式化
export let toFixedData=function(data, userType, isDetail, symbol) {// 数据小数位规范，每个产品都有最小的单位，数值化处理规则，四舍五入
  var toFixedType = {
      1: {
          AUDJPY: 3,
          AUDUSD: 5,
          CADJPY: 3,
          EURGBP: 5,
          EURJPY: 3,
          EURUSD: 5,
          GBPJPY: 3,
          GBPUSD: 5,
          NZDUSD: 5,
          EURAUD: 5,
          USDJPY: 3,
          USDCHF: 5,
          USDCAD: 5,
          GBPAUD: 5,
          NZDCAD: 5,
          EURCAD: 5,
          GBPCAD: 5,
          USDCNH: 5,
          // fx
          XAUUSD: 2,
          XAGUSD: 3,
          USOIL: 2,
          UKOIL: 2,
          CU: 4,
          // indices
          US30: 0,
          NAS100: 2,
          SPX500: 2,
          GER30: 1,
          FRA40: 1,
          CN300: 1,
          HSI33: 0,
          China_A50: 0,
          USDX: 3,
          // currencies
          BTCUSD: 2,
          LTCUSD: 2,
          ETHUSD: 2
      },
      2: {
          AUDJPYe: 3,
          AUDUSDe: 5,
          CADJPYe: 3,
          EURGBPe: 5,
          EURJPYe: 3,
          EURUSDe: 5,
          GBPJPYe: 3,
          GBPUSDe: 5,
          NZDUSDe: 5,
          EURAUDe: 5,
          USDJPYe: 3,
          USDCHFe: 5,
          USDCADe: 5,
          GBPAUDe: 5,
          NZDCADe: 5,
          EURCADe: 5,
          GBPCADe: 5,
          USDCNHe: 5,
          // fx
          XAUUSDe: 2,
          XAGUSDe: 3,
          USOIL: 2,
          UKOIL: 2,
          CU: 4,
          // indices
          US30: 0,
          NAS100: 2,
          SPX500: 2,
          GER30: 1,
          FRA40: 1,
          CN300: 1,
          HSI33: 0,
          China_A50: 0,
          USDX: 3,
          // currencies
          BTCUSD: 2,
          LTCUSD: 2,
          ETHUSD: 2
      }
  }
  // 默认
  var figure = 5
  for (var key in data) {
      var showArr = ['high', 'low', 'sell', 'buy']
    if (isDetail) {
  console.log('********toFixedData',data)
        
          // 详情
          if (toFixedType[userType][symbol] || toFixedType[userType][symbol] == 0) {
              figure = toFixedType[userType][symbol];
          }
          console.log(symbol+'详情原始数据：================', data.symbol_prices.sell, data.symbol_prices.buy, data.symbol_prices.low, data.symbol_prices.high)
        for (var i in showArr) {
            if (data.symbol_prices !== void 0) {
              data.symbol_prices[showArr[i]] = Number(data.symbol_prices[showArr[i]]).toFixed(figure)
            }
        }
        console.log('figure', symbol,figure,toFixedType[userType],symbol)
        console.log(symbol+'详情修改后数据：===========', data.symbol_prices.sell, data.symbol_prices.buy, data.symbol_prices.low, data.symbol_prices.high)
      } else {
          // 列表页
          // console.log(key+'原始数据：================', data[key].price.sell, data[key].price.buy, data[key].price.low, data[key].price.high)
          if (toFixedType[userType][key] || toFixedType[userType][key] == 0) {
              figure = toFixedType[userType][key];
          }
          for (var y in  showArr) {
            if (data[key].price !== void 0) {
              data[key].price[showArr[y]] = Number(data[key].price[showArr[y]]).toFixed(figure)
            }
          }
          // console.log('figure', figure,toFixedType[userType][key])
          // console.log(key+'修改后数据：===========', data[key].price.sell, data[key].price.buy, data[key].price.low, data[key].price.high)
        
      }
    
      
      
     
  }
  return data
}
